/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateWillRequestStatusDto = {
    newStatus: UpdateWillRequestStatusDto.newStatus;
    note?: string;
    changedByUser: string;
};
export namespace UpdateWillRequestStatusDto {
    export enum newStatus {
        NEW = 'NEW',
        ACCEPTED_BY_SOLICITOR = 'ACCEPTED_BY_SOLICITOR',
        DECLINED = 'DECLINED',
        ASSIGNED_TO_SOLICITOR = 'ASSIGNED_TO_SOLICITOR',
        WILL_COMPLETE = 'WILL_COMPLETE',
        PAYMENT_DECLINED = 'PAYMENT_DECLINED',
        REQUEST_COMPLETE = 'REQUEST_COMPLETE',
        DECLINED_BY_SOLICITOR = 'DECLINED_BY_SOLICITOR',
        DECLINED_BY_PLATFORM = 'DECLINED_BY_PLATFORM',
    }
}

